import { DEFAULT_CONFIG } from './config.js';
import { clamp } from './util.js';
/** Ports `playableRecommendation()`. */
export function playableRecommendation(value) {
    return value === 'UP' || value === 'DOWN';
}
/** Ports `validContractPrice()`. */
export function validContractPrice(value) {
    return Number.isFinite(value) && value > 0 && value < 1;
}
/**
 * Ports `decide()`. `config.marketUpPrice` reproduces the Scriptable
 * script's optional fixed UP-contract price / expected-value check; leave
 * it `null` (the default) to skip that gate, matching the script's default.
 */
export function decide(signal, calibration, config = DEFAULT_CONFIG) {
    const action = signal.action;
    const p = calibration.probability;
    let marketProb = null;
    let edge = null;
    if (config.marketUpPrice != null) {
        const upPrice = clamp(Number(config.marketUpPrice), 0.01, 0.99);
        marketProb = action === 'UP' ? upPrice : 1 - upPrice;
        edge = p - marketProb;
    }
    const reasonsToSkip = [];
    if (signal.secondsRemaining < config.minSecondsRemaining) {
        reasonsToSkip.push('Too little time remains in this round');
    }
    if (Math.abs(signal.rawScore) < config.minRawScore) {
        reasonsToSkip.push('Signal score is too weak');
    }
    if (p < config.minPlayProbability) {
        reasonsToSkip.push('Calibrated probability is below threshold');
    }
    if (edge != null && edge < config.minEdge) {
        reasonsToSkip.push('Prediction-market price does not offer enough edge');
    }
    if (signal.regime === 'CHOP' && p < 0.68) {
        reasonsToSkip.push('Choppy market requires a stronger setup');
    }
    const recommendation = reasonsToSkip.length ? 'SKIP' : action;
    return {
        recommendation,
        directionalAction: action,
        probability: p,
        marketProb,
        edge,
        reasonsToSkip,
        strength: recommendation === 'SKIP'
            ? 'NO CLEAN EDGE'
            : p >= config.strongProbability
                ? 'STRONG'
                : 'PLAY',
    };
}
//# sourceMappingURL=decision.js.map